import React, { useState, useEffect, useRef } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { FeedbackWrapper, Wrapper } from "./styles"
import { Twitter } from "../Twitter"
import { Youtube } from "../Youtube"
import { FeedbackImage } from "../FeedbackImage"

export function Feedback() {
	const data = useStaticQuery(graphql`
		query MyQuery {
			allAirtable(sort: { fields: data___CreatedDate, order: DESC }) {
				nodes {
					id
					data {
						ID
						SheroesLInk
						CreatedDate
						YoutubeLink
						TwitterLink
						Attachments {
							id
							url
						}
					}
				}
			}
		}
	`)

	// Array of all news articles
	const allItems = data.allAirtable.nodes

	// State for the list
	const [list, setList] = useState([...allItems.slice(0, 12)])

	// State to trigger oad more
	const [loadMore, setLoadMore] = useState(false)

	// State of whether there is more to load
	const [hasMore, setHasMore] = useState(allItems.length > 12)

	//Set a ref for the loading div
	const loadRef = useRef()

	// Handle intersection with load more div
	const handleObserver = entities => {
		const target = entities[0]
		if (target.isIntersecting) {
			setLoadMore(true)
		}
	}

	//Initialize the intersection observer API
	useEffect(() => {
		var options = {
			root: null,
			rootMargin: "20px",
			threshold: 1.0,
		}
		const observer = new IntersectionObserver(handleObserver, options)
		if (loadRef.current) {
			observer.observe(loadRef.current)
		}
	}, [])

	// Handle loading more articles
	useEffect(() => {
		if (loadMore && hasMore) {
			const currentLength = list.length
			const isMore = currentLength < allItems.length
			const nextResults = isMore
				? allItems.slice(currentLength, currentLength + 12)
				: []
			setList([...list, ...nextResults])
			setLoadMore(false)
		}
	}, [loadMore, hasMore]) //eslint-disable-line

	//Check if there is more
	useEffect(() => {
		const isMore = list.length < allItems.length
		setHasMore(isMore)
	}, [list]) //eslint-disable-line

	return (
		<Wrapper>
			{list.map(item => (
				<FeedbackWrapper>
					{item.data.YoutubeLink !== null ? (
						<Youtube link={item.data.YoutubeLink} />
					) : (
						[
							item.data.TwitterLink !== null ? (
								<Twitter link={item.data.TwitterLink} />
							) : (
								<FeedbackImage
									link={item.data.SheroesLInk}
									imageUrl={item.data.Attachments[0].url}
								/>
							),
						]
					)}
				</FeedbackWrapper>
			))}
			<div ref={loadRef}>{hasMore && <p>Loading...</p>}</div>
		</Wrapper>
	)
}
